<template>
  <span>
    <navbar />
    <router-view />
    <invite-users
      v-if="modal.showing"
      name="header-invite-users"
    ></invite-users>
    <footer-view />
  </span>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import FooterView from "@/components/FooterView.vue";
import InviteUsers from "@/views/vendors/partials/InviteUsers";
import { mapState } from "vuex";

export default {
  name: "SignedIn",
  computed: {
    ...mapState(["modal"]),
  },
  components: {
    Navbar,
    FooterView,
    InviteUsers,
  },
};
</script>
